import React from "react";
import {
	DiHtml5,
	DiCss3,
	DiJavascript1,
	DiPhp,
	DiReact,
	DiNodejs,
	DiMongodb,
	DiMysql,
	DiComposer,
} from "react-icons/di";
import {
	SiNextdotjs,
	SiXampp,
	SiYaml,
	SiDynamics365,
	SiMicrosoftsqlserver,
	SiLaravel,
} from "react-icons/si";
import { FaGitAlt, FaGithub, FaGitlab } from "react-icons/fa";

// components
import Card from "../Card";

const techStacks = [
	{
		id: 1,
		title: "HTML",
		icon: <DiHtml5 />,
		color: "text-green-800",
		level: 5,
	},
	{
		id: 2,
		title: "CSS",
		icon: <DiCss3 />,
		color: "text-green-800",
		level: 4,
	},
	{
		id: 3,
		title: "JavaScript",
		icon: <DiJavascript1 />,
		color: "text-green-800",
		level: 4,
	},
	{
		id: 4,
		title: "PHP",
		icon: <DiPhp />,
		color: "text-green-800",
		level: 4,
	},
	{
		id: 5,
		title: "Reactjs",
		icon: <DiReact />,
		color: "text-green-800",
		level: 3,
	},
	{
		id: 6,
		title: "Node.js",
		icon: <DiNodejs />,
		color: "text-green-800",
		level: 3,
	},
	{
		id: 7,
		title: "Next.js",
		icon: <SiNextdotjs />,
		color: "text-green-800",
		level: 3,
	},
	{
		id: 8,
		title: "Laravel",
		icon: <SiLaravel />,
		color: "text-green-800",
		level: 3,
	},
	{
		id: 9,
		title: "MongoDB",
		icon: <DiMongodb />,
		color: "text-green-800",
		level: 3,
	},
	{
		id: 10,
		title: "MySQL",
		icon: <DiMysql />,
		color: "text-green-800",
		level: 3,
	},
	{
		id: 12,
		title: "Dynamics365",
		icon: <SiDynamics365 />,
		color: "text-green-800",
		level: 4,
	},
	{
		id: 13,
		title: "Microsoft SQL",
		icon: <SiMicrosoftsqlserver />,
		color: "text-green-800",
		level: 4,
	},
	{
		id: 14,
		title: "YAML",
		icon: <SiYaml />,
		color: "text-green-800",
		level: 3,
	},
	{
		id: 11,
		title: "XAMPP",
		icon: <SiXampp />,
		color: "text-green-800",
		level: 3,
	},
	{
		id: 15,
		title: "Composer",
		icon: <DiComposer />,
		color: "text-green-800",
		level: 3,
	},
	{
		id: 16,
		title: "Git",
		icon: <FaGitAlt />,
		color: "text-green-800",
		level: 5,
	},
];

const techStackCards = techStacks.map((techStack) => (
	<Card
		key={techStack.id}
		title={techStack.title}
		icon={techStack.icon}
		color={techStack.color}
		level={techStack.level}
	/>
));

const TechStack = () => {
	return (
		<div>
			<h1 className="text-center text-5xl font-bold mb-2 py-2">
				Professional <span className="text-green-800">Skillset:</span>
			</h1>
			<div className="p-5 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-5">
				{techStackCards}
			</div>
		</div>
	);
};

export default TechStack;
